export const DISPLAY_MODE = {
    GRID: 'grid',
    PAGING: 'paging',
    SLIDER: 'slider',
    SIMPLE_GRID: 'simpleGrid'
};

export const GAME_SIZES = {
    EXTRA_SMALL: 'extraSmall',
    SMALL: 'small',
    OPTIONAL_SMALL: 'optional_small', /* Lugano changes */
    MEDIUM: 'medium',
    LARGE: 'large'
};

/* Lugano changes */
export const GAME_WIDTHS = {
    [GAME_SIZES.EXTRA_SMALL]: {
        MOBILE: 63,
        DESKTOP: 63
    },
    [GAME_SIZES.SMALL]: {
        MOBILE: 110,
        DESKTOP: 145
    },
    [GAME_SIZES.OPTIONAL_SMALL]: {
        MOBILE: 120,
        DESKTOP: 150
    },
    [GAME_SIZES.MEDIUM]: {
        MOBILE: 158,
        DESKTOP: 200
    },
    [GAME_SIZES.LARGE]: {
        MOBILE: 254,
        DESKTOP: 300
    }
};

export const GAMES_PER_ROW = 4;

export const ROWS_IN_COLLAPSED_CATEGORY = 2;
/* Lugano changes */
